import { useRoutesContext } from '@src/app/context/Routes/Routes';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { isEmpty, orderBy } from 'lodash';
import React, { useMemo } from 'react';

import { Styles } from './includes/styles';

/**
 * SubMenu
 *
 * Provides the user with a sub menu.
 *
 * @param items
 * @returns {Element}
 * @constructor
 */
export function SubMenu({ items }) {
  const { currentRoute } = useRoutesContext();

  const theItems = useMemo(() => {
    return orderBy(items, ['menuOrder'], ['asc']);
  }, [items]);

  return (
    <ErrorHandler location="src/layouts/Application/sections/Header/components/Navigation/components/SubMenu/SubMenu.jsx">
      {!isEmpty(theItems) && (
        <Styles>
          <NavMenuPrimitives.Columns>
            <NavMenuPrimitives.Column>
              {theItems?.map((subItem) => {
                if (subItem?.showInNavigation === true) {
                  return (
                    <NavMenuPrimitives.MenuItem
                      className={
                        currentRoute?.path === subItem?.path || currentRoute?.path?.includes(subItem?.path)
                          ? 'active'
                          : ''
                      }
                      href={subItem?.path}
                      key={`${subItem?.accessor}-childItem`}
                      title={subItem?.navigationLabel}
                    />
                  );
                }

                return <React.Fragment key={`${subItem?.accessor}-childItem`} />;
              })}
            </NavMenuPrimitives.Column>
          </NavMenuPrimitives.Columns>
        </Styles>
      )}
    </ErrorHandler>
  );
}
